import { render, staticRenderFns } from "./buyCardApply.vue?vue&type=template&id=1c85521b&scoped=true&"
import script from "./buyCardApply.vue?vue&type=script&lang=js&"
export * from "./buyCardApply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c85521b",
  null
  
)

export default component.exports